<div class="page-title__bar">
  <h2 class="title">User Management</h2>

  <div class="user-actions">
    <div
      *ngIf="(userRole === 'location_admin' || userRole === 'location_user') && uniqueLocations?.length > 1"
      class="loc-selector"
    >
      <i class="fa fa-map-marker loc-selector__icon" aria-hidden="true"></i>
      <select
        class="loc-selector__select"
        [(ngModel)]="activeLocationId"
        (change)="onLocationChange()"
      >
        <option [value]="null">Select location</option>
        <option *ngFor="let loc of uniqueLocations" [value]="loc.location.location_id">
          {{ loc.location.description }}
          {{ loc.role === "location_admin" ? "(Admin)" : "(User)" }}
        </option>
      </select>
    </div>
    <div *ngIf="userRole === 'practice_admin'" class="input-group" (keyup.enter)="filterUsers(searchBar.value)">
      <input #searchBar type="search" class="form-control change" placeholder="Search By Email" />
      <div class="input-group-append" (click)="filterUsers(searchBar.value)">
        <span class="input-group-text">
          <img src="../../../assets/icons/daily-screening.svg" alt="search" />
        </span>
      </div>
    </div>
    <button class="btn add-user-btn" (click)="addUser()">
      {{ userRole === "user" ? "Add User" : "Invite User" }}
      <i class="fa fa-plus ml-2" aria-hidden="true"></i>
    </button>
  </div>
</div>
<br />
<div *ngIf="showAdminOnlyMessage" class="ml-3" style="min-width:260px;">
      <div class="alert alert-info m-0" role="alert" style="padding:8px 12px; font-size:14px;">
        Only location admins can view and manage users for the selected location.
      </div>
  </div>

<div *ngIf="!showAdminOnlyMessage" class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="calendar" role="tabpanel" aria-labelledby="calendar-tab">
    <div class="right__panel calendar-data__wrapper">
      <div class="table-data__wrapper table-responsive calendar-data--table">
        <app-table-pagination-client
          [headers]="userRole === 'practice_admin' ? tableHeaders : referralTableHeaders"
          [data]="usersData"
          [hasActions]="true"
          [toggleUserStatus]="toggleUserStatus"
          [changeUserStaus]="true"
          [userRoleDeleteFunction]="
          userRole === 'practice_message_admin'
            ? null
            : (userRole === 'practice_admin' || userRole === 'practice_admin_sante_community' || userRole === 'practice_admin_sante_community_order')
            ? deleteUser
            : deleteLocationUser
        "
          [pageSize]="pageSize"
          [resetPassword]="resetPassword"
          [editFunction]="editUser"
          (setTotalPages)="setTotalPages($event)"
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [paginateId]="1"
          [pageSize]="10"
          [currentPage]="1"
          [currentUser]="currentUser"
        >
        </app-table-pagination-client>
      </div>
    </div>
  </div>
</div>
